var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSingleProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9V15C22.5 16.1 21.6 17 20.5 17H19.5V15H20.5V9H4.5V15H10.5V17H4.5C3.4 17 2.5 16.1 2.5 15V9C2.5 7.9 3.4 7 4.5 7H20.5C21.6 7 22.5 7.9 22.5 9ZM15 19L16.09 16.59L18.5 15.5L16.09 14.41L15 12L13.91 14.41L11.5 15.5L13.91 16.59L15 19ZM17.5 14L18.12 12.62L19.5 12L18.12 11.38L17.5 10L16.88 11.38L15.5 12L16.88 12.62L17.5 14ZM15 19L16.09 16.59L18.5 15.5L16.09 14.41L15 12L13.91 14.41L11.5 15.5L13.91 16.59L15 19ZM17.5 14L18.12 12.62L19.5 12L18.12 11.38L17.5 10L16.88 11.38L15.5 12L16.88 12.62L17.5 14Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleProduct);
export default __webpack_public_path__ + "static/media/single-product.ea42860578ea299f467ae526e2ed0b3d.svg";
export { ForwardRef as ReactComponent };